// Generated by CoffeeScript 2.4.1
(function() {
  var Operation, Record, Weaver, WeaverAttribute, WeaverNode, _, util,
    indexOf = [].indexOf;

  Weaver = require('./Weaver');

  WeaverNode = require('./WeaverNode');

  Operation = require('./Operation');

  util = require('./util');

  _ = require('lodash');

  Record = class Record {
    constructor(fromNode, value1, dataType1, attNode1) {
      this.fromNode = fromNode;
      this.value = value1;
      this.dataType = dataType1;
      this.attNode = attNode1;
    }

    equals(record) {
      return record instanceof WeaverAttribute.Record && record.attNode.equals(this.attNode);
    }

  };

  WeaverAttribute = (function() {
    class WeaverAttribute {
      constructor(owner, key1) {
        this.owner = owner;
        this.key = key1;
        this._pendingWrites = [];
        this._records = [];
      }

      pendingWrites() {
        return this._pendingWrites;
      }

      _removeRecord(record) {
        var i, rec, results;
        i = 0;
        results = [];
        while (i < this._records.length) {
          rec = this._records[i];
          if (rec.equals(record)) {
            results.push(this._records.splice(i, 1));
          } else {
            results.push(i++);
          }
        }
        return results;
      }

      all() {
        var add, j, len, list, record, ref;
        list = [];
        ref = this._records;
        for (j = 0, len = ref.length; j < len; j++) {
          record = ref[j];
          add = true;
          list.push(record.value);
        }
        return list;
      }

      allRecords() {
        return this._records;
      }

      getRecordForAttNode(attNode) {
        var j, len, record, ref;
        ref = this._records;
        for (j = 0, len = ref.length; j < len; j++) {
          record = ref[j];
          if (record.attNode.equals(attNode)) {
            return record;
          }
        }
        return void 0;
      }

      first(params = {}) {
        var attribute, rec, recs, ref;
        if (this.allRecords().length > 1) {
          console.warn('Called first() on attribute with more than one record');
        }
        recs = (function() {
          var j, len, ref, results;
          ref = this.allRecords();
          results = [];
          for (j = 0, len = ref.length; j < len; j++) {
            rec = ref[j];
            results.push({
              rec,
              cr: rec.attNode._createdAt
            });
          }
          return results;
        }).call(this);
        recs = _.orderBy(recs, 'cr', 'asc');
        attribute = (ref = recs[recs.length - 1]) != null ? ref.rec : void 0;
        if (attribute != null) {
          return WeaverAttribute.evokeValue(attribute.value, attribute.dataType, params);
        }
      }

      add(value, params = {}) {
        var attributeNode, eventData, eventMsg, oldRecord, operation;
        if (value == null) {
          return this.removeAll();
        }
        params.owner = this.owner;
        params.key = this.key;
        if (params.dataType == null) {
          params.dataType = util.guessDataType(value);
        }
        params.value = WeaverAttribute.parseValue(value, params.dataType);
        if (params.addToPendingWrites == null) {
          params.addToPendingWrites = true;
        }
        operation = Operation.Node(this.owner).createAttribute(params);
        this.pendingWrites().push(operation);
        eventMsg = 'node.attribute';
        eventData = {
          node: this.owner,
          graph: operation.graph,
          field: params.key,
          value: params.value
        };
        if (params.replaces != null) {
          eventMsg += '.update';
          oldRecord = this._records[0];
          this._removeRecord(oldRecord);
          eventData.oldValue = oldRecord != null ? oldRecord.value : void 0;
        } else {
          eventMsg += '.set';
        }
        Weaver.publish(eventMsg, eventData);
        attributeNode = this._createAttributeNode(operation, params);
        this._records.push(new Record(this.owner, params.value, params.dataType, attributeNode));
        return attributeNode;
      }

      _createAttributeNode(operation, params) {
        var result;
        result = Weaver.AttributeNode.get(operation.id, {
          graph: operation.graph,
          NodeClass: Weaver.AttributeNode
        });
        result.fromNode = params.owner;
        result.key = params.key;
        result.value = params.value;
        result.dataType = params.dataType;
        if (params.created != null) {
          result._createdAt = params.created;
        }
        if (params.creator != null) {
          result._createdBy = params.creator;
        }
        return result;
      }

      only(value, params = {}) {
        var ref;
        params.replaces = (ref = this._records[0]) != null ? ref.attNode : void 0;
        params.upsert = true;
        return this.add(value, params);
      }

      removeAll() {
        var j, len, record, ref, results;
        Weaver.publish('node.attribute.unset', {
          node: this.owner,
          field: this.key
        });
        ref = this._records;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          record = ref[j];
          results.push(this.remove(record));
        }
        return results;
      }

      remove(record) {
        // remove locally
        this._removeRecord(record);
        // destroy attribute
        if (record.attNode._stored) {
          return this.pendingWrites().push(Operation.Node(this.owner).removeAttribute({
            key: this.key,
            node: record.attNode
          }));
        }
      }

      static compareAndValidate(rawValue, {dataType, existingAttribute, confirm}) {
        var confirmed, differentDataType, e, oldValue, update, value, xsdDataType;
        if (existingAttribute instanceof Weaver.Attribute) {
          existingAttribute = existingAttribute.allRecords()[0];
        }
        try {
          // Estabilish dataType
          if (dataType == null) {
            dataType = util.guessDataType(rawValue);
          }
          xsdDataType = dataType;
          if (dataType === 'file' || dataType === 'fileId') {
            xsdDataType = 'wvr:fileId';
          }
          if (dataType === 'string') {
            xsdDataType = 'xsd:string';
          }
          if (dataType === 'date') {
            xsdDataType = 'xsd:dateTime';
          }
          if (dataType === 'boolean') {
            xsdDataType = 'xsd:boolean';
          }
          if (dataType === 'double') {
            xsdDataType = 'xsd:double';
          }
          if (dataType === 'integer') {
            xsdDataType = 'xsd:integer';
          }
          if (dataType === 'json') {
            xsdDataType = 'xsd:string';
          }
          if (!((typeof xsdDataType.startsWith === "function" ? xsdDataType.startsWith('xsd:') : void 0) || (typeof xsdDataType.startsWith === "function" ? xsdDataType.startsWith('wvr:') : void 0))) {
            throw Error(`Could not map ${dataType} to xsd data types`);
          }
          // Estabilish value (and optionally oldValue)
          value = WeaverAttribute.parseValue(rawValue, dataType);
          if (confirm != null) {
            oldValue = WeaverAttribute.parseValue(confirm, dataType);
          }
          differentDataType = (existingAttribute != null) && dataType !== existingAttribute.dataType;
          update = (existingAttribute == null) || differentDataType || !WeaverAttribute.compareValues(existingAttribute.value, value, dataType);
          confirmed = (existingAttribute != null) && WeaverAttribute.compareValues(existingAttribute.value, oldValue, dataType);
          return {
            value, // any:     the value after parsing
            dataType, // string:  the data type
            xsdDataType, // string:  the xsd data type the dataType argument is mapped to
            update, // boolean: true if the value is different from the old value (true if no old attribute is specified)
            confirmed, // boolean: true if the oldRawValue is equal to the existing value (false if no old attribute is specified)
            valid: true // boolean: true if the value could be succesfully parsed
          };
        } catch (error) {
          e = error;
          return {
            value: void 0,
            dataType: void 0,
            xsdDataType: void 0,
            update: false,
            confirmed: false,
            valid: false,
            reason: e.message
          };
        }
      }

      // Internal representation to usable format
      static evokeValue(value, dataType, params = {}) {
        if (params.dontEvoke) {
          return value;
        }
        if (indexOf.call(WeaverAttribute.typesDate, dataType) >= 0) {
          return util.evokeDate(value, Weaver.timeLibrary);
        } else if (indexOf.call(WeaverAttribute.typesJson, dataType) >= 0) {
          return util.evokeJSON(value, dataType === 'json5');
        } else {
          return value;
        }
      }

      // User input to internal representation
      static parseValue(value, dataType) {
        var forceUTC, number;
        if (dataType == null) {
          throw new Error('When calling parseValue dataType is undefined');
        }
        if (value == null) {
          throw new Error('When calling parseValue value is undefined');
        }
        if (indexOf.call(WeaverAttribute.typesBoolean, dataType) >= 0) {
          return util.parseBoolean(value);
        } else if (indexOf.call(WeaverAttribute.typesDate, dataType) >= 0) {
          forceUTC = dataType === 'xsd:date';
          return util.parseDate(value, Weaver.timeLibrary, forceUTC);
        } else if (indexOf.call(WeaverAttribute.typesInteger, dataType) >= 0) {
          number = util.parseNumber(value);
          if (number % 1 !== 0) {
            throw new Error('Can not parse decimal number to integer type');
          }
          return number;
        } else if (indexOf.call(WeaverAttribute.typesDouble, dataType) >= 0) {
          return util.parseNumber(value);
        } else if (indexOf.call(WeaverAttribute.typesTime, dataType) >= 0) {
          return util.parseTime(value);
        } else if (indexOf.call(WeaverAttribute.typesJson, dataType) >= 0) {
          return util.parseJSON(value, dataType === 'json5');
        } else if (indexOf.call(WeaverAttribute.typesString, dataType) >= 0) {
          return util.parseString(value);
        } else {
          console.warn(`Datatype ${dataType} is not known, storing it as string`);
          return util.parseString(value);
        }
      }

      static compareValues(value, other, dataType) {
        return value === other;
      }

      static withVarsMap(query) {
        var assignment, j, key, len, map, ref, value;
        map = {};
        ref = [...query.matchAll(/%\{([^\}]+)\}/g)];
        // look for %{var=value}
        for (j = 0, len = ref.length; j < len; j++) {
          assignment = ref[j];
          [key, ...value] = assignment[1].split('=');
          if (map[key] != null) {
            throw Error(`Key ${key} is defined multiple times`);
          }
          map[key] = value.join('=').trim();
        }
        return map;
      }

      static parseWithVars(query) {
        var key, mapInQuery, re, value;
        mapInQuery = this.withVarsMap(query);
        for (key in mapInQuery) {
          value = mapInQuery[key];
          re = new RegExp('%\{\s*' + key + '\s*=([^\}]+)\}', 'g');
          query = query.replace(re, function(a, b) {
            return b.trim();
          });
        }
        return query;
      }

      static updateWithVars(query, map) {
        var key, mapInQuery, re, value;
        mapInQuery = this.withVarsMap(query);
        for (key in mapInQuery) {
          value = mapInQuery[key];
          value = map[key] || value;
          re = new RegExp('%\{\s*' + key + '\s*=([^\}]+)\}', 'g');
          query = query.replace(re, function(a, b) {
            return `%{${key}=${value}}`;
          });
        }
        return query;
      }

    };

    WeaverAttribute.Record = Record;

    WeaverAttribute.typesBoolean = ['boolean', 'xsd:boolean'];

    WeaverAttribute.typesInteger = ['integer', 'xsd:long', 'xsd:int', 'xsd:integer', 'xsd:short', 'xsd:byte', 'xsd:nonPositiveInteger', 'xsd:negativeInteger', 'xsd:nonNegativeInteger', 'xsd:positiveInteger', 'xsd:unsignedLong', 'xsd:unsignedInt', 'xsd:unsignedShort', 'xsd:unsignedByte'];

    WeaverAttribute.typesDouble = ['double', 'xsd:float', 'xsd:decimal', 'xsd:double'];

    WeaverAttribute.typesDate = ['date', 'xsd:date', 'xsd:dateTime'];

    WeaverAttribute.typesString = ['string', 'fileId', 'xsd:anyURI', 'xsd:base64Binary', 'xsd:duration', 'xsd:hexBinary', 'xsd:gDay', 'xsd:gMonth', 'xsd:gMonthDay', 'xsd:gYear', 'xsd:gYearMonth', 'xsd:OTATION', 'xsd:QName', 'xsd:string', 'wvr:fileId'];

    WeaverAttribute.typesTime = ['time', 'xsd:time'];

    WeaverAttribute.typesJson = ['json', 'json5', 'json5-with-vars'];

    return WeaverAttribute;

  }).call(this);

  // Export
  module.exports = WeaverAttribute;

}).call(this);
